<template>
  <div class="bp-header">
    <b-navbar type="is-primary">
      <template slot="brand">
        <router-link to="/" class="uk-navbar-item uk-logo">
          <img
            class="navbar-logo"
            :src="logo"
            :alt="$t('message.bizpal_logo_alt')"
            :title="$t('message.bizpal_title')"
          /> </router-link
      ></template>
      <template slot="start">
        <p class="is-size-3">
          {{ $t("message.bizpal_title") }} <sup>{{ $t("message.beta") }}</sup>
        </p>
      </template>
      <template slot="end">
        <b-navbar-dropdown
          :label="$t('message.dropdown_title')"
          class="testnav"
        >
          <b-navbar-item @click="aboutModal()">
            {{ $t("about.title") }}
          </b-navbar-item>
          <!-- temporarily hidden until FAQ is written
          <b-navbar-item href="#" @click="faqModal()">
              {{ $t("faq.title") }}
          </b-navbar-item> -->
          <!-- temporarily hidden until feedback form is implemented
          <b-navbar-item href="#">
            {{ $t("message.feedback_link") }}
          </b-navbar-item> -->
          <b-navbar-item @click="contactModal()">
            {{ $t("contact.title") }}
          </b-navbar-item>
        </b-navbar-dropdown>
        <b-navbar-item id="lang" tabindex="0" @keyup.enter="onEnter" @click.prevent="changeLang()">
          {{ $t("message.language_switcher") }}
        </b-navbar-item>
      </template>
    </b-navbar>
  </div>
</template>

<script>
import FaqModal from "@/components/FaqModal.vue";
import AboutModal from "@/components/AboutModal.vue";
import ContactModal from "@/components/ContactModal.vue";

export default {
  name: "NavBar",
  created: function() {
    if (this.$route.query.lang) {
      this.changeLang(this.$route.query.lang);
    }
  }, //created
  data: function() {
    return {
      envMode: process.env.NODE_ENV
    };
  },
  computed: {
    logo: function() {
      var logo = "";
      if (this.$i18n.locale == "fr") {
        logo = "/images/bizpal-logo-fr.png";
      } else {
        logo = "/images/bizpal_logo_eng.png";
      }
      return logo;
    }
  },
  methods: {
    changeLang: function() {
      if (this.$i18n.locale === "en") {
        this.$i18n.locale = "fr";
      } else {
        this.$i18n.locale = "en";
      }
      return this.$i18n.locale;
    },
    onEnter(event) {
      if (event) {
        document.getElementById(event.target.id).click()
      }
    },
    aboutModal: function() {
      this.$buefy.modal.open({
        parent: this,
        component: AboutModal,
        hasModalCard: true
      });
    },
    faqModal: function() {
      this.$buefy.modal.open({
        parent: this,
        component: FaqModal,
        hasModalCard: true
      });
    },
    contactModal: function() {
      this.$buefy.modal.open({
        parent: this,
        component: ContactModal,
        hasModalCard: true
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.navbar-logo {
  height: 52px;
  width: auto;
}
@media only screen and (min-width: 1024px) {
  ::v-deep .navbar-item.has-dropdown.is-active > .navbar-dropdown {
    display: block;
  }
}
</style>
